import { render, staticRenderFns } from "./CouponPreviewBenefit.vue?vue&type=template&id=f5c1ccbc&scoped=true&"
import script from "./CouponPreviewBenefit.vue?vue&type=script&lang=js&"
export * from "./CouponPreviewBenefit.vue?vue&type=script&lang=js&"
import style0 from "./CouponPreviewBenefit.vue?vue&type=style&index=0&id=f5c1ccbc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c1ccbc",
  null
  
)

export default component.exports